export const environment = {
  production: false,
  env: 'dev' as const,
  apiUrl: 'https://europe-west1-southern-sol-491601-e9.cloudfunctions.net',
  gaMeasurementId: 'G-2SK447B1SG',
  gaDebugMode: true,
};
